import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';

import { apiQuery } from 'src/api';
import { Link } from 'src/components/link';
import LogoKoyeb from 'src/components/logo-koyeb.svg?react';
import { FeatureFlag } from 'src/hooks/feature-flag';

import { OrganizationProjectSwitcher } from '../organization-project-switcher';
import { OrganizationSwitcher } from '../organization-switcher';

import { UserMenu } from './user-menu';

export function SecondaryLayoutHeader({ className }: { className?: string }) {
  const { data: hasMultipleOrganizations } = useQuery({
    ...apiQuery('get /v1/account/organizations', { query: {} }),
    select: ({ organizations }) => organizations!.length > 1,
  });

  return (
    <header
      className={clsx(
        'fixed inset-x-0 top-0 z-10 row flex-wrap items-center gap-4 bg-linear-to-b from-neutral from-75% to-transparent p-4',
        className,
      )}
    >
      <Link to="/">
        <LogoKoyeb className="h-8" />
      </Link>

      {hasMultipleOrganizations && (
        <FeatureFlag feature="simple-projects" fallback={<OrganizationSwitcher />}>
          <OrganizationProjectSwitcher className="w-48" />
        </FeatureFlag>
      )}

      <div className="ml-auto">
        <UserMenu />
      </div>
    </header>
  );
}
